const baseStyle = () => {
  return {
    _disabled: {
      opacity: 1.0,
      offTrackColor: 'gray.200',
      onTrackColor: 'gray.200',
    },
    _invalid: {
      borderWidth: 2,
      borderRadius: 12,
    },
    onThumbColor: 'white',
    offThumbColor: 'white',
    _light: {
      offTrackColor: 'gray.200',
      onTrackColor: `blue.500`,
      _hover: {
        offTrackColor: 'gray.300',
        onTrackColor: `blue.400`,
      },
      _invalid: {
        borderColor: 'error.500',
      },
    },
    _dark: {
      offTrackColor: 'gray.200',
      onTrackColor: `blue.500`,
      _hover: {
        offTrackColor: 'gray.300',
        onTrackColor: `blue.400`,
      },
      _invalid: {
        borderColor: 'error.500',
      },
    },
  };
};

const sizes = {
  sm: {
    margin: -1,
    marginLeft: -1.5,
    marginRight: -1.5,
    style: {
      transform: [{ scale: 0.75 }],
    },
  },
  md: {
    margin: 0,
    style: {
      transform: [{ scale: 1 }],
    },
  },
  lg: {
    margin: 0,
    style: {
      transform: [{ scale: 1 }],
    },
  },
};

const defaultProps = {
  size: 'lg',
};

export default {
  baseStyle,
  sizes,
  defaultProps,
};
